module.exports = __webpack_public_path__ + "media/images/emblems/Onsernone-coat_of_arms-b8bf395bc1f7f062d6d1b136375cd932.svg";